var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cms-partial-template"},[_c(_vm.htmlComponent,{tag:"component"}),(_vm.css)?_c("style",{tag:"component"},[_vm._v(_vm._s(_vm.css))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }